/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useFetchPosProfileDetails } from '../user';
import { selectAuth, selectCart, selectOrder } from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { DeleteKOTType } from '@/types/utils';
import { closeModal } from '@/store/slices/modal';
import { handleApiError } from '@/utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const fetcher = (url: any, invoiceData: DeleteKOTType) => {
  const response = axios({
    method: 'post',
    url: `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.delete_draft_invoice`,
    data: { data: { ...invoiceData } },
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useDeleteDraftInvoice = () => {
  const { url } = useSelector(selectAuth);
  const { data: posProfile } = useFetchPosProfileDetails();
  const navigate = useNavigate();
  const { items, subtotal } = useSelector(selectCart);
  const { restaurant_table, customer, current_invoice } =
    useSelector(selectOrder);
  const dispatch = useDispatch();

  const invoiceData: DeleteKOTType = {
    company: posProfile?.company,
    restaurant: posProfile?.restaurant,
    name: current_invoice,
    restaurant_table,
    discount_amount: 0,
    customer,
    subtotal,
    items,
    pos_profile: posProfile,
  };

  const handleSuccess = () => {
    dispatch(closeModal({ type: 'submitPayment' }));
    dispatch(
      setAlert({ type: 'success', message: 'Order cancelled successfully!' }),
    );
    navigate('/tables');
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
  };

  const mutate = useMutation(() => fetcher(url, invoiceData), {
    onSettled: (data) => {
      if (!data.data) {
        const errorMessage = handleApiError(data);
        handleError(errorMessage);
      } else if (data.data) {
        handleSuccess();
      }
    },
    onError: () => handleError('An Error Occured. Contact Administration'),
  });

  return mutate;
};
